import { settingsStore, updateSettings } from "../../stores/settingsStore";

const TRIGGERS: {
  id: "response-ready" | "cli-idle" | "approval-needed";
  label: string;
  help: string;
}[] = [
  { id: "response-ready", label: "Response ready", help: "When a chat finishes streaming." },
  { id: "cli-idle", label: "CLI idle", help: "When a terminal stops emitting output." },
  {
    id: "approval-needed",
    label: "Approval needed",
    help: "When a policy verdict needs your input.",
  },
];

export function NotificationsPanel() {
  const state = settingsStore.useStore();
  const n = state.settings.notifications;

  return (
    <div className="settings-panel">
      <h3>Notifications</h3>
      <label className="settings-checkbox">
        <input
          type="checkbox"
          checked={n.enabled}
          onChange={(e) => void updateSettings({ notifications: { enabled: e.target.checked } })}
        />
        Enable notifications
      </label>
      <h4 className="settings-subhead">Triggers</h4>
      {TRIGGERS.map((t) => (
        <label key={t.id} className="settings-checkbox">
          <input
            type="checkbox"
            checked={n.triggers[t.id]}
            onChange={(e) =>
              void updateSettings({ notifications: { triggers: { [t.id]: e.target.checked } } })
            }
          />
          <span>
            {t.label}
            <span className="settings-help-inline"> — {t.help}</span>
          </span>
        </label>
      ))}
      <h4 className="settings-subhead">Chime</h4>
      <label className="settings-checkbox">
        <input
          type="checkbox"
          checked={n.chime}
          onChange={(e) => void updateSettings({ notifications: { chime: e.target.checked } })}
        />
        Play sound on notification
      </label>
    </div>
  );
}
